
































import { Prop, Component, Vue, Watch, Ref } from 'vue-property-decorator';
import {
  getMinValue,
  getMaxValue,
} from '@getaccept/editor-lib/src/helpers/pricing-table/pricing-table-units-modifier-menu.helper';
import { PricingTableHelper, EUnitInputType } from '@getaccept/editor-lib';
import type { IField, NumberInputSettings } from '@getaccept/editor-lib';
import DropdownItemsWrapper from '@getaccept/editor-lib/src/components/DropdownItemsWrapper.vue';

@Component({
  components: {
    DropdownItemsWrapper,
  },
  data: () => ({
    PricingTableHelper,
    EUnitInputType,
    getMinValue,
    getMaxValue,
  }),
})
export default class PricingTableUnitsModifierMenu extends Vue {
  @Prop() inputField: IField & { inputSettings: NumberInputSettings };
  @Prop() open: boolean;
  @Prop() disabled: boolean;

  @Watch('open') watchOpen() {
    if (!this.open) {
      return;
    }
    this.defaultValueError = '';
  }

  @Ref('defaultValueInput') defaultValueInput: HTMLInputElement;

  defaultValueError = '';

  close() {
    this.$emit('close');
  }

  handleEsc() {
    this.close();
  }

  handleEnter(event: FocusEvent) {
    this.handleDefaultValueBlur(event);
    if (this.defaultValueError === '') {
      this.close();
    }
  }

  handleDefaultValueBlur(event: FocusEvent) {
    const { value } = event.target as HTMLInputElement;
    if (this.inputField.value === value || this.defaultValueError !== '') {
      return;
    }
    const removeLeadingZeros = String(parseInt(value, 10));
    this.$emit('update-field', { id: this.inputField.id, value: removeLeadingZeros });
  }

  handleDefaultValueChange(value: string) {
    const minValue = getMinValue(this.inputField);
    const maxValue = getMaxValue(this.inputField);
    if (minValue === null || maxValue === null) {
      this.defaultValueError = '';
    } else if (Number(minValue) > 0 && Number(value) < Number(minValue)) {
      this.defaultValueError = 'default-value-error-cant-be-lower-than-min-value';
    } else if (Number(maxValue) > 0 && Number(value) > Number(maxValue)) {
      this.defaultValueError = 'default-value-error-cant-be-higher-than-max-value';
    } else {
      this.defaultValueError = '';
    }
  }
}
